import { render, staticRenderFns } from "./EditDate.vue?vue&type=template&id=3747d5be&scoped=true"
import script from "./EditDate.vue?vue&type=script&lang=ts"
export * from "./EditDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3747d5be",
  null
  
)

export default component.exports